import { useSelector } from 'react-redux';

import { ProgressBar } from '@utilities';

import styles from './_index.module.scss';

const Credits = () => {
  const { clientInfo, surveyInfo } = useSelector((state) => state?.user?.data || {});

  const userCredits = Number(surveyInfo?.userCredits ?? 0);
  const promoCredits = Number(surveyInfo?.promoCredits ?? 0);
  const creditsExpiry = surveyInfo?.creditsExpiry || '';

  const clientName = clientInfo?.name || '';
  const totalClientCredits = Number(clientInfo?.totalCredits ?? 0);
  const inFlightClientCredits = Number(clientInfo?.inFlightCredits ?? 0);
  const availableClientCredits = Math.max(0, totalClientCredits - inFlightClientCredits);

  const maxBase = Math.max(userCredits, availableClientCredits, promoCredits, 1);
  const maxScaled = Math.max(1, Math.floor(maxBase));

  const rows = [
    {
      barClass: styles['credits-bar-green'],
      key: 'user',
      label: 'Your Credits',
      value: userCredits,
    },
    {
      barClass: styles['credits-bar-neutral'],
      key: 'client',
      label: `${clientName} Credits`,
      value: availableClientCredits,
    },
    ...(promoCredits > 0
      ? [
          {
            barClass: styles['credits-bar-mint'],
            key: 'promo',
            label: 'Promotional Credits',
            value: promoCredits,
          },
        ]
      : []),
  ];

  return (
    <div aria-label="Credits overview">
      {rows.map(({ barClass, key, label, value }) => (
        <div key={key}>
          <p className={styles['credits-progress-bar-label']}>
            <span>{label}</span>
            <span>{value}</span>
          </p>
          <ProgressBar
            aria-label={`${label} progress`}
            className={barClass}
            label={null}
            max={maxScaled}
            value={value}
          />
        </div>
      ))}

      {creditsExpiry && (
        <p>
          *All {clientName} credits expire on <strong>{creditsExpiry}</strong>
        </p>
      )}
    </div>
  );
};

export default Credits;
